import {
  FolderOpen, Loader2, PauseCircle, CheckCircle2, Clock,
  AlertTriangle, Archive
} from "lucide-react";

export const C = {
  blue:   "#3B82F6", purple: "#8B5CF6", orange: "#F59E0B",
  green:  "#10B981", teal:   "#06B6D4", red:    "#EF4444",
  indigo: "#6366F1", pink:   "#EC4899", slate:  "#64748B"
};

export const PERIODS = ["Weekly","15 Days","Monthly","Quarterly","Half-yearly","Yearly","Select Range"];

export const KPI_MULT = {
  Weekly: .15, "15 Days": .35, Monthly: 1,
  Quarterly: 3, "Half-yearly": 5.5, Yearly: 11, "Select Range": .2
};


export const aT = { fontSize: 9, fill: "#94A3B8" };

export const KPIS_BASE = [
  { label:"Open Tasks",       val:493,  color:C.blue,   bg:"#EFF6FF", Icon:FolderOpen,    trend:"up", chip:"+12%", sub:"vs last month", up:true  },
  { label:"In Progress",      val:878,  color:C.purple, bg:"#F5F3FF", Icon:Loader2,       trend:"up", chip:"+8%",  sub:"vs last month", up:true  },
  { label:"On Hold",          val:35,   color:C.orange, bg:"#FFFBEB", Icon:PauseCircle,   trend:"dn", chip:"-3%",  sub:"vs last month", up:false },
  { label:"Completed",        val:765,  color:C.green,  bg:"#ECFDF5", Icon:CheckCircle2,  trend:"up", chip:"+22%", sub:"vs last month", up:true  },
  { label:"Pending Approval", val:73,   color:C.teal,   bg:"#ECFEFF", Icon:Clock,         trend:"nt", chip:"—",    sub:"Unchanged",     up:false },
  { label:"Overdue",          val:1732, color:C.red,    bg:"#FEF2F2", Icon:AlertTriangle, trend:"dn", chip:"!",    sub:"Needs attention",up:false },
  { label:"Closed Tasks",     val:412,  color:C.slate,  bg:"#F8FAFC", Icon:Archive,       trend:"up", chip:"+15%", sub:"vs last month", up:true  },
];
